import React, { useState, useEffect } from 'react';
import GameSettings from './GameSettings';

const CreateLobby = ({ 
  selectedCategory, 
  setSelectedCategory, 
  selectedDifficulty, 
  setSelectedDifficulty, 
  questionCount, 
  setQuestionCount, 
  muted, 
  setMuted, 
  onCreateLobby, 
  loading, 
  error,
  onBack 
}) => {
  const [playerName, setPlayerName] = useState('');

  // Log component lifecycle
  useEffect(() => {
    console.log('[CreateLobby] Component mounted/updated', {
      selectedCategory,
      selectedDifficulty,
      questionCount,
      muted,
      loading,
      hasError: !!error,
      playerName
    });
  }, [selectedCategory, selectedDifficulty, questionCount, muted, loading, error, playerName]);

  const handleCreateLobby = () => {
    if (!playerName.trim()) {
      console.log('[CreateLobby] Player name is required');
      return;
    }
    
    console.log('[CreateLobby] Creating lobby with settings:', {
      playerName: playerName.trim(),
      selectedCategory,
      selectedDifficulty,
      questionCount,
      muted
    });
    
    onCreateLobby(playerName.trim());
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleCreateLobby();
    }
  };

  return (
    <div className="game-card">
      <h1><span role="img" aria-label="users">👥</span> Create Lobby</h1>
      <p>Set up a multiplayer game for you and your friends!</p>
      
      <div className="lobby-settings">
        <div className="setting-group">
          <label>Your Name:</label>
          <input
            type="text"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter your name"
            className="player-name-input"
            maxLength={20}
          />
        </div>
        
        <GameSettings
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedDifficulty={selectedDifficulty}
          setSelectedDifficulty={setSelectedDifficulty}
          questionCount={questionCount}
          setQuestionCount={setQuestionCount}
          muted={muted}
          setMuted={setMuted}
        />
      </div>
      
      <div className="button-group">
        <button 
          className="back-button" 
          onClick={onBack}
        >
          ← Back
        </button>
        
        <button 
          className="start-button" 
          onClick={handleCreateLobby}
          disabled={loading || !playerName.trim()}
        >
          {loading ? 'Creating Lobby...' : 'Create Lobby'}
        </button>
      </div>
      
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default CreateLobby;
